import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({}))

export default styles
